import { useEffect } from "react";
import { ErrorPopup } from "../../component/ErrorPopup";
import { PriceModel } from "../../model/PriceModel";
import { ContactToSellMyFruit } from "../ContactToSellMyFruit";

type Props = {
    winningPrice?: PriceModel
    needTransport?: boolean
    page: string
}

export function StepPriceReceived({winningPrice, needTransport, page}: Props) {

    useEffect(() => {
        window.gtag("event", "page_view", { page_path: page });
        // eslint-disable-next-line
    }, [])

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", width: "100%", height: "100%" }}>
            {
                winningPrice?.id === -1 ?
                    <ErrorPopup style={{}} message="No Price for you" isVisible={true} onClose={() => { }} />
                    :
                    <ContactToSellMyFruit style={{}} price={winningPrice?.pricePerUnit!!} type={needTransport ? "farm" : "mill"} />
            }
        </div>
    )
}